import {
  GET_LIST_MAU_IN,
  GET_LIST_MAU_IN_SUCCESS,
  GET_LIST_MAU_IN_FAILURE,
  GET_NOI_DUNG_IN,
  GET_NOI_DUNG_IN_SUCCESS,
  GET_NOI_DUNG_IN_FAILURE,
} from "./actionTypes";

export const getListMauIn = () => ({
  type: GET_LIST_MAU_IN,
});

export const getListMauInSuccess = (data) => ({
  type: GET_LIST_MAU_IN_SUCCESS,
  payload: data,
});

export const getListMauInFailure = () => ({
  type: GET_LIST_MAU_IN_FAILURE,
});

export const getNoiDungIn = (dataSearch) => ({
  type: GET_NOI_DUNG_IN,
  dataSearch,
});

export const getNoiDungInSuccess = (data) => ({
  type: GET_NOI_DUNG_IN_SUCCESS,
  payload: data,
});

export const getNoiDungInFailure = () => ({
  type: GET_NOI_DUNG_IN_FAILURE,
});
